import React from "react";
import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/system";
import styled from "styled-components";

const ChatIconButton = ({
  color,
  fontWeight,
  fontSize,
  icon,
  borderColor,
  label,
  boxShadow,
  background,
  onClick,
  fontFamily,
  type,
  iconPosition = "start",
  padding,
  loading,
  disabled,
}) => {
  return (
    <Wrapper>
      <button
        onClick={onClick}
        type={type}
        disabled={disabled}
        style={{
          border: `2px solid ${borderColor}`,
          background: background,
          boxShadow: boxShadow,
          borderRadius: "30px",
          padding: padding,
          cursor: "pointer",
        }}
        className="add_notes"
      >
        {iconPosition === "start" && <>{icon}</>}
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Typography
            textAlign="left"
            color={color}
            fontSize={fontSize}
            // fontFamily={fontFamily}
            fontWeight={fontWeight}
            sx={{ ml: 0.6 }}
          >
            {label}
          </Typography>
          {loading && (
            <CircularProgress size="1.5rem" sx={{ color: "white" }} />
          )}
        </Box>
        {iconPosition === "end" && <>{icon}</>}
      </button>
    </Wrapper>
  );
};

export default ChatIconButton;

const Wrapper = styled.div`
  .button-container {
    border: none;
    outline: none;
    color: ${(props) => props.theme?.gradientButton?.text};
    border-radius: 30px;
    padding: 0.6em 2em;
  }
  .add_notes {
    display: flex;
    align-items: center;
    // min-width: 105px;
    width: fit-content;
    // margin-left: 1em;
    padding: 0.4em 0.8em;
    // cursor: pointer;
    border-radius: 30px;
  }
  .small_button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    width: fit-content;
    margin-left: 0.5em;
    padding: 0.5em;
    cursor: pointer;
    border-radius: 30px;
  }
  .small-gradient {
    background: ${(props) => props.theme?.gradientButton?.background};
    border: none;
    outline: none;
    color: ${(props) => props.theme?.gradientButton?.text};
    border-radius: 30px;
    padding: 1em 3em;
    // width: 100px;
  }
`;
